import React from 'react';
import './SwingTimeline.css';

const parsed = value => typeof value === 'string' ? Date.parse(value) : NaN;
const date = value => new Date(parsed(value)).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const validWindow = value => value && Number.isFinite(parsed(value.from)) && Number.isFinite(parsed(value.through)) && parsed(value.from) <= parsed(value.through);
function Window({ value }) {
  return validWindow(value) ? <span title={`${value.from} – ${value.through} (UTC)`}>{date(value.from)} – {date(value.through)}</span> : <span>Not established</span>;
}
function age(window, asOf, intraday) {
  if (!validWindow(window) || !Number.isFinite(parsed(asOf)) || parsed(window.through) > parsed(asOf)) return null;
  const youngest = (parsed(asOf) - parsed(window.through)) / 86400000;
  const oldest = (parsed(asOf) - parsed(window.from)) / 86400000;
  if (intraday) return `About ${Math.floor(youngest * 24)}–${Math.ceil(oldest * 24)} hours at report time`;
  if (oldest < 1) return 'Less than one day at report time';
  const low = Math.floor(youngest), high = Math.ceil(oldest);
  return `About ${low === high ? low : `${low}–${high}`} days at report time`;
}
export default function SwingTimeline({ swing, asOf, intraday = false }) {
  const timeline = swing?.timeline;
  const observation = swing?.observation;
  const phase = swing?.state === 'WEAKENING' ? 'Weakening began (estimated)' : 'Current phase began (estimated)';
  return <div className="swingTimeline">
    <h4>Swing timeline</h4>
    <dl>
      <div><dt>Swing began (estimated)</dt><dd><Window value={timeline?.startedBetween}/>{age(timeline?.startedBetween, asOf, intraday) && <small>{age(timeline.startedBetween, asOf, intraday)}</small>}</dd></div>
      <div><dt>{phase}</dt><dd><Window value={timeline?.stateSinceBetween}/>{age(timeline?.stateSinceBetween, asOf, intraday) && <small>{age(timeline.stateSinceBetween, asOf, intraday)}</small>}</dd></div>
      <div><dt>System first recorded this swing</dt><dd>{Number.isFinite(parsed(observation?.firstObservedAt)) ? date(observation.firstObservedAt) : 'Not recorded'}</dd></div>
      <div><dt>System first recorded this phase</dt><dd>{Number.isFinite(parsed(observation?.stateFirstObservedAt)) ? date(observation.stateFirstObservedAt) : 'Not recorded'}</dd></div>
    </dl>
    {timeline ? <p>{timeline.confidence && <strong>Timing certainty: {String(timeline.confidence).toLowerCase()}. </strong>}{timeline.evidence}</p>
      : <p>This report predates swing timeline tracking. Its publication date does not identify when the move began.</p>}
    <p className="swingTimelineNote">Dates use your local time. Estimated dates are reconstructed from price history; recorded dates show when our system accepted the assessment. Tracking restarts after a reporting gap or a new or uncertain swing origin. Ages are measured at report time.</p>
  </div>;
}
